// extracted by mini-css-extract-plugin
module.exports = {"root":"Category_root__3Lcob","label":"Category_label__3lXil","content":"Category_content__33p75","header":"Category_header__1m2hf","location":"Category_location__1BTeK"};